/** Users — edit form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  USER_STATUS,
  updateUserSchema,
  type User,
  type UpdateUserInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader, LoadingState, ErrorState } from "../projects/_shared";
import { FormGrid, SelectField, TextField } from "../projects/_form";
import { UserAccessSections } from "../admin/UserAccessSections";

export function UserEdit() {
  const form = useForm<User, any, UpdateUserInput>({
    resolver: zodResolver(updateUserSchema),
    refineCoreProps: { resource: "users", action: "edit" },
  });

  const {
    refineCore: { formLoading, query },
    saveButtonProps,
    control,
  } = form;

  if (query?.isLoading) {
    return <LoadingState label="Loading user…" />;
  }
  if (query?.isError) {
    return <ErrorState error={query.error} />;
  }

  const userId = query?.data?.data?.id;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="Edit User" description="Update user details." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">User details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="display_name"
                  label="Name"
                />
                <TextField
                  control={control}
                  name="email"
                  label="Email"
                  type="email"
                />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={USER_STATUS}
                />
              </FormGrid>
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Saving…" : "Save Changes"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>

      {userId ? <UserAccessSections userId={userId} /> : null}
    </div>
  );
}

export default UserEdit;
